export default {
  subtitle_entity_not_found: "We didn't find any {entity}s.",
  subtitle_entity_not_found_exclamation: "We didn't find any {entity}s!",
  subtitle_entity_not_added: "There are no {entity}s added.",
  subtitle_entity_no_matches: "We didn't find any results for your search.",
  subtitle_entity_not_open: "You're not presently assigned to any open {entity}.",
  subtitle_performed_work: "We didn't find any Performed Work.",
  subtitle_workspace_not_found:
    "We could not find any Workspace that your user account can access.",
  subtitle_unsubmitted_work_not_found: "You have no unsubmitted work at ",
  subtitle_notifications_not_found: "You have not yet received any Notification.",
  subtitle_entity_not_assigned: "You're not presently assigned to any {entity}.",
  subtitle_attachment_drag_and_drop: "Or browse via the button above.",
  subtitle_no_related_actions: "This Item has neither Issues, nor Work Orders.",
  subtitle_no_attributes: "You must select an <span class='text-weight-bold'>Item Class</span>",
  subtitle_to_do: "You have not made any To-Dos.",
  subtitle_no_issues_raised: "There were no Issues raised from this <b>Performed Work</b>",
  subtitle_no_comments: "Nobody has commented on this <b>{entity}</b>",
  subtitle_location_not_associated: "This item has no associated Location!",
  subtitle_add_image: "Click to add the first Image!",
  subtitle_work_order_not_created:
    "Key parameters such as Work Domain, Work type and Entity type must be set before this panel can function. </br></br> First, create the Work Order.",
  subtitle_no_work_issues: "Select the Issues for which Work must be performed.",
  subtitle_no_work_items: "Select the Items for which Work must be performed.",
  subtitle_no_suitable_work_orders: "We didn't find any suitable Work Order.",

  title_entity_not_found: "No {entity}s",
  title_entity_no_matches: "No matching {entity}s",
  title_entity_no_matches_found: "No matches",
  title_entity_not_assigned: "No {entity} assignments.",
  title_entity_not_open: "No open {entity}s!",
  title_entity_not_created: "{entity} not yet created",
  title_unsubmitted_work_no_matches: "No matching {entity}",

  title_no_entity: "No {entity}",
  title_no_entities: "No {entity}s!",
  title_no_images: "No Images!",
  title_notifications_not_found: "There are no Notifications",
  title_unsubmitted_work_not_found: "No Unsubmitted Work!",
  title_workspaces_not_found: "No Workspaces!",
  title_workspace_not_found: "No Workspace!",
  title_attachment_drag_and_drop: "Drag and drop to add {entity} Attachments",
  title_no_related_actions: "No related actions / events",
  title_no_attributes: "Attributes appear here",
  title_no_issues_raised: "No Issues raised!",
  title_no_comments: "No Comments!",
  title_no_location: "No Location",
  title_no_work_issues: "No Work Issues",
  title_no_work_items: "No Work Items",

  contact_administrator: "Please, contact your administrator!",
  http_404: "HTTP 404",
  this_workspace: "this workspace",

  // Quotes

  quote_workspace_not_found: "This is re-he-heally awkward",
  quote_workspace_no_matches:
    "Well that was a long walk down a windy beach to a café that was closed",

  quote_area_not_found: "Fetch straightedge and compass!",
  quote_area_no_matches: "Consult the scrolls once more and the fabled place may be found.",

  quote_notification_not_found: "Good news, everyone! There are no news.",

  quote_to_do_not_found: "Nothing to see here, folks, move along.",

  quote_layout_not_found: "The Workspace is Terra Incognita.",
  quote_layout_no_matches: "You're off the edge of the map, mate. Here there be monsters.",

  quote_performed_work_not_found:
    "If you can’t work from home, go to work. Don't go to work! Go outside. Don't go outside! And then we will or won't, something or other...",
  quote_performed_work_no_matches: "Does that mean it isn’t broke or... we didn't fix it?",

  quote_zone_not_found: "Zones specify important types of regions.",
  quote_zone_no_matches: "Perhaps there's a hole in the Zone layer!",

  quote_unsubmitted_work_not_found: "Work, or work not, there is no try",

  quote_issue_no_matches:
    "Know your Issues and know yourself and you can have a hundred Workspaces without disaster",
  quote_issue_not_found:
    "As many a brash youth swept in twilight’s gleam and coaxed by sweet notes of well-hopped ale bursts through the tavern doors, eyes afire for some foe, alike in prowess, finding none but fair friends<br><br>So you, searched for Issues and found none",

  quote_work_order_not_assigned: "It's the Workspace of the free!",
  quote_work_order_not_created: "Strucky has locksed again!",
  quote_work_order_not_found: "Laissez faire, laissez passer",
  quote_work_order_no_matches: "A Work Order by any other name may smell as sweet!",
  quote_work_order_not_open: "Thy work is done!",

  quote_attachment_drag_and_drop: "Be the first to sow this fertile land!",
  quote_attachment_not_found: "The best of us have pressed “send” without double-checking.",
  quote_attachment_no_matches: "These aren't the Attachments you're looking for.",
  quote_attachment_not_added: "Should have mailed them to the Marx brothers!",

  quote_item_not_found: "There is plenty of room for all kinds of stuff.",
  quote_item_no_matches: "... though we may have some in the back in a size L",
  quote_no_related_actions: "It’s the job that’s never started as takes longest to finish.",

  quote_location_not_found: "It is a vast country with landmarks unknown.",
  quote_location_no_matches: "I have no memory of this place.",

  quote_no_location:
    "Have you not heard the stories? It’s an Item that cannot be found except by those who already know where it is..",

  quote_model_not_found:
    "And the workspace abounded with novel Items, each hand-wrought and bespoke but for a single purpose.",
  quote_model_no_matches: "Try again! Maybe you'll get another one. A better one!",
  quote_attributes: "It's a bird, it's a plane. No! It's... what is it?",

  quote_bug_found:
    "Scientists say the universe is made up of protons, neutrons and electrons. They forget to mention MORONS!",
  quote_no_issues_raised: "No news is good news!..<br/> right?",
  quote_no_comments: "‘No comment’ is a splendid expression. I am using it again and again.",
}
